"use strict";
var AvailablePackages = (function () {
    function AvailablePackages() {
    }
    return AvailablePackages;
}());
exports.AvailablePackages = AvailablePackages;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/licensing/available-packages.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/licensing/available-packages.model.js